import { LineChart } from 'lucide-react'

interface ChartEmptyOverlayProps {
  title?: string
  message?: string
  heightClassName?: string
}

export function ChartEmptyOverlay({
  title = 'No data yet',
  message = "We're ready when you are!",
  heightClassName = 'h-64',
}: ChartEmptyOverlayProps): JSX.Element {
  return (
    <div className={`relative w-full overflow-hidden rounded-lg bg-gray-50 ${heightClassName}`}>
      <div aria-hidden className="absolute inset-0 flex flex-col justify-between px-6 py-4">
        <div className="h-px bg-gray-200/80" />
        <div className="h-px bg-gray-200/80" />
        <div className="h-px bg-gray-200/80" />
        <div className="h-px bg-gray-200/80" />
        <div className="h-px bg-gray-200/80" />
      </div>
      <div aria-hidden className="absolute inset-y-4 left-6 w-px bg-gray-200/80" />
      <div aria-hidden className="absolute inset-y-4 right-6 w-px bg-gray-200/80" />

      <div className="relative flex h-full items-center justify-center">
        <div
          role="status"
          className="flex flex-col items-center gap-2 rounded-lg border border-gray-200 bg-white px-5 py-4 text-center shadow-sm"
        >
          <LineChart className="h-6 w-6 text-brand-green" aria-hidden />
          <p className="text-sm font-semibold text-gray-700">{title}</p>
          <p className="max-w-xs text-xs text-gray-500">{message}</p>
        </div>
      </div>
    </div>
  )
}
